import React, { useState } from 'react'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { Text, Title, Paragraph } from '../../../assets/Text'
import { MessengerInput } from '../../../assets/Chat'
import GH from '../../../helpers/GeneralHelper'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import CustomTheme from '../../../assets/CustomTheme'
import * as Icons from '../../../assets/Icons'
import Divider from '@mui/material/Divider'

/**
 * usage:
    <ProfileCard 
        display_name=''
        age=''
        gender=''
        state_address=''
        relationship=''
        loss_description=''
        component={}
    />
 */
const ProfileCard = props => {
    // console.log(`card props`, props)
    const [supportMsg, updateSupportMsg] = useState('')
    const lang = props.lang
    if(!props.hasOwnProperty('profile') 
    || !props.profile.hasOwnProperty('display_name') 
    || !props.profile.hasOwnProperty('age') 
    || !props.profile.hasOwnProperty('gender')
    || !props.profile.hasOwnProperty('state_address') 
    || !props.profile.hasOwnProperty('loss_description')
    || !props.profile.hasOwnProperty('study_field')
    || !props.profile.hasOwnProperty('problem_category_1')
    || !props.profile.hasOwnProperty('problem_category_2')
    || !props.profile.hasOwnProperty('problem_category_3')
    || !props.profile.hasOwnProperty('living_situation')
    || !props.profile.hasOwnProperty('hobbies_description')
    || !props.profile.hasOwnProperty('coping_strategy_1')
    || !props.profile.hasOwnProperty('coping_strategy_2')
    || !props.profile.hasOwnProperty('coping_strategy_3')
    )
    {
        return <CircularProgress />
    }
    //console.log(props.profile)
    return (<CustomTheme>
    <Grid container
        sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            boxShadow: 4,
        }}
    >
        <Grid item xs sm md lg xl>
            <Grid container
                sx={{
                    // bgcolor: 'primary.light',
                    display: {
                        xs: "column",
                        sm: "row",
                        md: "row"
                    },
                    px: {
                        md: 3,
                        sm: 3,
                        xs: 1
                    },
                    py: {
                        md: 4,
                        sm: 3,
                        xs: 1
                    }
                }}
            >
                {/** Left panel for the avatar and hug number */}
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}
                    sx={{
                        pr: {
                            md: 4,
                            sm: 3,
                            xs: 0
                        },
                        py: {
                            xs: 2
                        }
                    }}
                >
                    {/* avatar */}
                    <Stack direction={{ xs: 'row', sm: 'row', md: 'column' }} 
                        sx={{
                            justifyContent: {
                                xs: 'space-between',
                                sm: 'space-between',
                                md: 'center'
                            },
                            alignItems: "center",
                            px: {
                                xs: 3
                            }
                        }}
                    >
                        <Box>
                            <Avatar sx={{
                                width: {
                                    md: '144px',
                                    sm: '128px',
                                    xs: '56px'
                                },
                                height: {
                                    md: '144px',
                                    sm: '128px',
                                    xs: '56px'
                                },
                                mt: 'auto',
                                ml: 'auto',
                                mr: 'auto',
                                mb: {
                                    md: '16px',
                                    sm: '16px',
                                    // xs: '8x'
                                },
                                bgcolor: 'primary.main'
                            }}>{props.profile.display_name.length > 1 ? `${props.profile.display_name[0].toUpperCase()}${props.profile.display_name[1].toUpperCase()}`:`${props.profile.display_name[0].toUpperCase()}`}</Avatar>
                            <Box>
                                <Paragraph variant="subtitle1" align="center" >{props.profile.display_name}</Paragraph>
                            </Box>
                        </Box>
                        {/** hug counts */}
                        {props.type !== "interactive" && <Stack direction={"column"}
                            sx={{
                                mt: 'auto',
                                mb: 'auto'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '64px',
                                    margin: 'auto'
                                }}
                            >
                                <Icons.HugsCountIcon style={{ width: '100%' }} />
                            </Box>
                            <Paragraph sx={{
                                    margin: 'auto'
                                }} variant="caption">{props.hasOwnProperty('hugs') && props.hugs !== null ? `${props.hugs.length} ${lang.hugs}`: lang.hugsComing}</Paragraph>
                        </Stack>}

                        {props?.type === "interactive" && <Stack>
                                {props.connectComponent}
                        </Stack>}

                    </Stack>
                    <Divider orientation="horizontal" flexItem sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }} />
                </Grid>
                
                <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} />
                                
                {/** Right panel for the user's information */}
                <Grid item xs sm md={7} lg={7} xl={7}>
                <Stack direction={"column"} spacing={3}
                    sx={{
                        px:{
                            md: 3,
                            sm: 2,
                            xs: 1
                        },
                        py: {
                            md: 3,
                            sm: 3,
                            xs: 3
                        }
                    }}
                >

                    <Box>
                        <Paragraph variant="h5" sx={{ color: 'primary.main', display: { md: 'block', sm: 'none', xs: 'none' } }}>{`${props.profile.age}, ${GH.capitalizeFirstLetter(props.profile.gender)}, ${props.profile.state_address}`}</Paragraph>
                        {/* <Paragraph variant="h5" sx={{ color: 'primary.main' }}>{`${props.lang.problemCategory}: ${props.profile.problem_category_1}, ${props.profile.problem_category_2}, ${props.profile.problem_category_3}`}</Paragraph> */}
                    </Box>

                    <Box>
                        <Paragraph variant="subtitle1"><span style={{ fontWeight: 'bold', color: '#000' }}>{props.lang.studyField}:</span> {props.profile.study_field}</Paragraph>
                        <Paragraph variant="subtitle1"><span style={{ fontWeight: 'bold', color: '#000' }}>{props.lang.LivingSituation}:</span> {props.profile.living_situation}</Paragraph>
                        {/* <Paragraph variant="subtitle1">{`${props.lang.copingStrategy}: ${props.profile.coping_strategy_1}, ${props.profile.coping_strategy_2}, ${props.profile.coping_strategy_3}`}</Paragraph> */}
                    </Box>
                    <Box>
                        <Paragraph variant="subtitle1" sx={{ fontWeight: 'bold', color: '#000' }}>{props.lang.myStory}</Paragraph>
                        <Paragraph variant="subtitle1">{`${props.profile.loss_description}`}</Paragraph>
                    </Box>

                    <Box>
                        <Paragraph variant="subtitle1" sx={{ fontWeight: 'bold', color: '#000' }}>{props.lang.hobbies}</Paragraph>
                        <Paragraph variant="subtitle1">{`${props.profile.hobbies_description}`}</Paragraph>
                    </Box>
                </Stack>
            </Grid>

        </Grid>
        {props.component ? props.component : null}
        {/*<Divider />

        <Grid item>

            <Grid container direction={'row'} justify={"center"} align={"center"} sx={{
                py: {
                    xs: 2, sm: 2, md: 2
                },
                px: {
                    xs: 2
                }
            }}>
                <Grid item xs={1.5} sm={1} md={1}>
                <Avatar sx={{
                    width: {
                        md: '64px',
                        sm: '64px',
                        xs: '40px'
                    },
                    height: {
                        md: '64px',
                        sm: '64px',
                        xs: '40px'
                    },
                    m: 'auto',
                    bgcolor: 'primary.main'
                }}>{props.profile.display_name.length > 1 ? `${props.profile.display_name[0].toUpperCase()}${props.profile.display_name[1].toUpperCase()}`:`${props.profile.display_name[0].toUpperCase()}`}</Avatar>
                </Grid>
                <Grid item xs sm md sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    px: 2
                }}>
                    <MessengerInput
                        placeholder={lang.leaveMessage}
                        onChange={e => updateSupportMsg(e.target.value)}
                        value={supportMsg}
                    />
                </Grid>
                <Grid item xs={1.5} sm={1} md={1}>
                    <IconButton color="primary" aria-label="send the supportive message"
                        onClick={() => null}
                    >
                        <Icons.SendIcon style={{ width: '100%' }} />
                    </IconButton>
                </Grid>
            </Grid>

        </Grid>*/}
    </Grid>


    </Grid>
        

    </CustomTheme>
    )
}

{/* <Grid item xs
sx={{
    // bgcolor: 'primary.light',
    display: "flex",
    flexDirection: {
        md: "column",
        sm: "column",
        xs: "row"
    },
    justifyContent: {
        md: "space-evenly",
        sm: "space-evenly",
        xs: "space-between"
    },
    px: {
        md: 4,
        sm: 0,
        xs: 4
    },
    // width: {
    //     md: "270px",
    //     sm: "180px",
    //     xs: "100%"
    // },
}}
>
<Box>
    <Avatar sx={{
        width: {
            md: '144px',
            sm: '128px',
            xs: '64px'
        },
        height: {
            md: '144px',
            sm: '128px',
            xs: '64px'
        },
        mt: 'auto',
        ml: 'auto',
        mr: 'auto',
        mb: {
            md: '16px',
            sm: '16px',
            // xs: '8x'
        },
        bgcolor: 'primary.main'
    }}>{props.profile.display_name.length > 1 ? `${props.profile.display_name[0].toUpperCase()}${props.profile.display_name[1].toUpperCase()}`:`${props.profile.display_name[0].toUpperCase()}`}</Avatar>
    <Box>
        <Paragraph variant="subtitle1" align="center" >{props.profile.display_name}</Paragraph>
    </Box>
</Box>

<Stack direction={"column"}
    sx={{
        mt: 'auto',
        mb: 'auto'
    }}
>
    <Box
        sx={{
            width: '64px',
            margin: 'auto'
        }}
    >
        <Icons.HugsCountIcon style={{ width: '100%' }} />
    </Box>
    <Paragraph sx={{
            margin: 'auto'
        }} variant="caption">{props.hasOwnProperty('hugs') && props.hugs !== null ? `${props.hugs.length} ${lang.hugs}`: lang.hugsComing}</Paragraph>
</Stack>
</Grid>
<Divider orientation="vertical" flexItem sx={{
display: { xs: 'none', sm: 'none', md: 'block' }
}} />
<Grid item xs={12} sm={8} md={8} 
sx={{
    display: "flex",
    flexDirection: {
        md: "column",
        sm: "column",
        xs: "row"
    },
    width: {

    }
}}
>
<Stack direction={"column"} spacing={3}
    sx={{
        pl:{
            md: 3,
            sm: 2,
            xs: 3
        },
        py: {
            md: 3,
            sm: 3,
            xs: 3
        }
    }}
>

    <Box>
        <Paragraph variant="h5" sx={{ color: 'primary.main' }}>{`${props.profile.age}, ${GH.capitalizeFirstLetter(props.profile.gender)}, ${props.profile.state_address}`}</Paragraph>
        <Paragraph variant="h5" sx={{ color: 'primary.main' }}>{`${props.lang.problemCategory}: ${props.profile.problem_category}`}</Paragraph>
    </Box>

    <Box>
        <Paragraph variant="subtitle1"><span style={{ fontWeight: 'bold', color: '#000' }}>{props.lang.studyField}:</span> {props.profile.study_field}</Paragraph>
        <Paragraph variant="subtitle1"><span style={{ fontWeight: 'bold', color: '#000' }}>{props.lang.LivingSituation}:</span> {props.profile.living_situation}</Paragraph>
        <Paragraph variant="subtitle1">{`${props.lang.copingStrategy}: ${props.profile.coping_strategy}`}</Paragraph>
    </Box>
    <Box>
        <Paragraph variant="subtitle1" sx={{ fontWeight: 'bold', color: '#000' }}>{props.lang.myStory}</Paragraph>
        <Paragraph variant="subtitle1">{`${props.profile.loss_description}`}</Paragraph>
    </Box>

    <Box>
        <Paragraph variant="subtitle1" sx={{ fontWeight: 'bold', color: '#000' }}>{props.lang.hobbies}</Paragraph>
        <Paragraph variant="subtitle1">{`${props.profile.hobbies_description}`}</Paragraph>
    </Box>
</Stack>
</Grid> */}

{/*<Grid container className={props.className ? `match-paper ${props.className}`:'match-paper'}>
        {props.topComponent !== null ? props.topComponent:null}
        <Grid item xs={12} sm={4} className='d-flex justify-content-center flex-column text-center py-3'>
        
            <div className='match-avatar mx-auto'>
                <Title className='p-0 m-0'>{props.profile.display_name.length > 1 ? `${props.profile.display_name[0].toUpperCase()}${props.profile.display_name[1].toUpperCase()}`:`${props.profile.display_name[0].toUpperCase()}`}</Title>
            </div>
            <div className='mt-3 px-5'>
                <Paragraph className='fyw-font-grey mx-auto'>{props.profile.display_name}</Paragraph>
            </div>
        </Grid>

        <Grid item xs={12} sm={8} className='py-5 pr-5'>
            <Grid>
                <Text className='fyw-font-grey m-0'>{`${props.profile.age}, ${GH.capitalizeFirstLetter(props.profile.gender)}, ${props.profile.state_address}`}</Text>
                <Text className='fyw-font-grey m-0'>{`${props.lang.problemCategory}: ${props.profile.problem_category}`}</Text>
            </Grid>

            <Grid>
                <Text className='fyw-font-grey m-0'>{`${props.lang.studyField}: ${props.profile.study_field}`}</Text>
                <Text className='fyw-font-grey m-0'>{`${props.lang.LivingSituation}: ${props.profile.living_situation}`}</Text>
                <Text className='fyw-font-grey m-0'>{`${props.lang.copingStrategy}: ${props.profile.coping_strategy}`}</Text>
            </Grid>
            <Grid><Text className='fyw-font-dark fyw-font-bold m-0 mt-4'>{props.lang.myStory}</Text></Grid>
            <Grid><Paragraph className='fyw-font-dark'>{`${props.profile.loss_description}`}</Paragraph></Grid>

            <Grid><Text className='fyw-font-dark fyw-font-bold m-0 mt-4'>{props.lang.hobbies}</Text></Grid>
            <Grid><Paragraph className='fyw-font-dark'>{`${props.profile.hobbies_description}`}</Paragraph></Grid>
        </Grid>
        
        {props.component ? props.component : null}

    </Grid>*/}
export default ProfileCard